import { createSlice } from '@reduxjs/toolkit'
const initialState = {
  id: '',
  name: '',
  announcements: [],
  permissions: [],
  data: {},
}
const reducers = {
  setAdmin: (state, action) => {
    return action.payload
  },
  setPermissions: (state, action) => {
    state.permissions = action.payload
  },
  setAnnouncements: (state, action) => {
    state.announcements = action.payload
  },
}
export const adminSlice = createSlice({
  name: 'admins',
  initialState,
  reducers,
})
export const { setAdmin, setPermissions, setAnnouncements } = adminSlice.actions
export default adminSlice.reducer
